module.exports = __webpack_public_path__ + "static/create-58896af802c2e23c91a64d7ab28d64ab.mp4";